import React, {Component} from 'react';
import {Container, Nav, Navbar} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import {LanguageStyle,LanguageWeb} from '../Redux/action';
import './navbar.css';

class NavBar extends Component {

	constructor(props) {
		super(props);
		this.state = {
			language: {
				name: 'en',
				label: 'English',
			},
		};
	}

	handleLanguage = (e) => {
		e.preventDefault();

		const en = {
			name: 'en',
			label: 'English',
		};
		const ar = {
			name: 'ar',
			label: 'العربية',
		};
		if (this.state.language.name === 'ar') {

			this.setState({language: en});

			this.props.setLanguage(this.state.language.name);
			this.props.language_web_m(this.state.language.label);

			document.getElementById('bootstrap').href = `${process.env.PUBLIC_URL}/bootstrap-rtl.css`;
			document.getElementsByTagName('html')[0].dir = 'rtl';
		} else if (this.state.language.name === 'en') {
			this.setState({
				language: ar,
			});
			this.props.setLanguage(this.state.language.name);
			this.props.language_web_m(this.state.language.label);
			document.getElementById('bootstrap').href = `${process.env.PUBLIC_URL}/bootstrap.css`;
			document.getElementsByTagName('html')[0].dir = 'ltr';
		}

	};

	render() {
		return (
				<Navbar className='nav-bar' expand="lg">
					<Container className="navConent">
						<div className='d-flex align-items-center'>
							<div className='ksu-logo'>
								<a href='https://ksu.edu.sa/ar'>
									<img alt="ksu logo" width={120} src={`${process.env.PUBLIC_URL}/ksu-logo.png`}/>
								</a>
							</div>
							<Link to="/" className="px-3">
								<img alt="Service Logo" src={`${process.env.PUBLIC_URL}/service_logo_black.png`} className="service-logo"/>
							</Link>
						</div>

						<Navbar.Toggle aria-controls="basic-navbar-nav"/>
						<Navbar.Collapse id="basic-navbar-nav">
							<Nav>
								<Link className="nav-link" to="/">
									<FormattedMessage id="nav.link.home" defaultMessage="Home"/>
								</Link>
								<Link className="nav-link" to="/howto">
									<FormattedMessage id="nav.link.howTo" defaultMessage="How To"/>
								</Link>
								<Link className="nav-link" to="/features">
									<FormattedMessage id="nav.link.features" defaultMessage="Features"/>
								</Link>
							</Nav>

							<Nav>
								<Link className="nav-link lang-btn" to="/" onClick={this.handleLanguage}>{this.state.language.label}</Link>
							</Nav>

						</Navbar.Collapse>
					</Container>
				</Navbar>
		);
	}

}

function mapDispatchToProps(dispatch) {
	return {
		setLanguage: (lang) => dispatch(LanguageStyle(lang)),
		language_web_m: (langs) => dispatch(LanguageWeb(langs))

	};
}

export default connect(null, mapDispatchToProps)(NavBar);
